exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".healthSurveyDownloadWrapper[data-v-2a2fe6b3]{margin:15px 0 50px}.surveyTermLabel[data-v-2a2fe6b3]{width:46px}.surveyTermText[data-v-2a2fe6b3]{margin:0 10px}.inputHealthSurvey[data-v-2a2fe6b3]{width:160px}", ""]);

// exports
